module.exports = __webpack_public_path__ + "static/img/nes.3973d17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/nes.png
// module id = 500
// module chunks = 1